import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { BsPencilSquare } from "react-icons/bs";
import { saveWeddingWebsiteImage, deleteWeddingWebsiteImage } from "../../../redux/rsvpSlice.js";

const ImageUpload = ({ defaultImage, imageName, canEdit, imageClass, alt, onNonEditClick, onChange, canDelete }) => {
  const dispatch = useDispatch();
  const [image, setImage] = useState(defaultImage);

  const handleDelete = async () => {
    await dispatch(deleteWeddingWebsiteImage({name:imageName}));
    if (onChange) onChange();
  }

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const uploadedImageUrl = e.target.result;
        setImage(uploadedImageUrl);

        var data = new FormData();
        data.append("image", file);
        data.append("filename", file.name);
        data.append("name", imageName);
        await dispatch(saveWeddingWebsiteImage(data));
        if (onChange) onChange();
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="banner-container">
      <img src={image} className={imageClass} alt={alt} 
        onClick={()=> !canEdit && onNonEditClick && onNonEditClick()}
      />
      {canEdit ? <>
        <label htmlFor={`file-upload-${imageName}`} className="upload-icon">
          <BsPencilSquare />
        </label>
        {canDelete && 
          <div style={{position:"absolute",left:"10px",top:"0",padding:"15px 20px",fontSize:"36px", color:"#fff", fontWeight:"bold", cursor:"pointer"}} 
          onClick={handleDelete}
          >X</div>
        }
        <input
          type="file"
          id={`file-upload-${imageName}`}
          accept="image/*"
          onChange={handleImageUpload}
          className="file-upload"
        />
      </> : null}
    </div>
  );
};

export default ImageUpload;
